"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTertiary = exports.ButtonComponent = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _EncoreContext = require("../../contexts/EncoreContext.js");
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _Button = require("./Button.js");
var _ButtonChildren = require("./ButtonChildren.js");
var _logging = require("../../logging.js");
var _excluded = ["component", "color", "children", "buttonSize", "semanticColor", "size", "hover", "active", "focus", "iconOnly", "iconLeading", "iconTrailing", "aria-label", "aria-labelledby", "aria-hidden", "condensed", "condensedAll"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ButtonComponent = exports.ButtonComponent = /*#__PURE__*/_react["default"].forwardRef(function ButtonComponent(_ref, ref) {
  var component = _ref.component,
    color = _ref.color,
    children = _ref.children,
    buttonSize = _ref.buttonSize,
    semanticColor = _ref.semanticColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    hover = _ref.hover,
    active = _ref.active,
    focus = _ref.focus,
    iconOnly = _ref.iconOnly,
    iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    ariaLabel = _ref['aria-label'],
    ariaLabelledby = _ref['aria-labelledby'],
    ariaHidden = _ref['aria-hidden'],
    condensed = _ref.condensed,
    condensedAll = _ref.condensedAll,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (iconOnly && !ariaLabel && !ariaLabelledby && !ariaHidden) {
    (0, _logging.warn)('ButtonTertiary must have an aria-label or aria-labelledby attribute defined when using the iconOnly prop in order to be accessible.');
  }
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  var config = (0, _react.useContext)(_EncoreContext.EncoreContext);
  var status = (0, _EncoreContext.getStatus)(_EncoreContext.encoreContextKeyword.button, config);
  var rel = props.href && props.target === '_blank' ? 'noopener noreferrer' : null;

  // TODO: Remove this once buttonSize is archived, and use size instead
  var localSize = buttonSize ? (0, _index.getNextControlSize)(buttonSize) : size;
  /** Override standard icon size for lg iconOnly buttons */
  var iconSize = iconOnly && localSize === 'large' ? 'large' : _index.controlIconSize[localSize];
  return /*#__PURE__*/_react["default"].createElement(_Button.Button, Object.assign({}, props, {
    className: (0, _classnames["default"])(!iconOnly && (0, _index.textClass)((0, _index.getButtonFont)(localSize, status)), props.className),
    rel: rel,
    ref: ref,
    component: !component && props.href ? 'a' : component,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-hidden": ariaHidden,
    $buttonSize: localSize,
    $iconSize: iconSize,
    $semanticColor: semanticColor,
    $iconLeading: iconLeading,
    $iconTrailing: iconTrailing,
    $iconOnly: iconOnly,
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $hover: hover,
    $active: active,
    $focus: focus,
    $condensed: condensed,
    $condensedAll: condensedAll,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ButtonTertiary
  }), /*#__PURE__*/_react["default"].createElement(_ButtonChildren.ButtonChildren, {
    iconOnly: iconOnly,
    iconLeading: iconLeading,
    iconTrailing: iconTrailing,
    iconSize: iconSize,
    children: children,
    buttonSize: localSize
  }));
});

/**
 * TODO: Remove when we deprecate `buttonSize` helpers like `ButtonTertiary.sm`.
 */
var buttonHelpers = _objectSpread(_objectSpread({}, _index.buttonSizesWithDeprecationWarning), {}, {
  displayName: 'ButtonTertiary'
});

/**
 * Tertiary buttons are text and icon-only buttons. These are used for the least important actions.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-buttonsecondary--docs) |
 * [Encore site](https://encore.spotify.net/web/components/buttons#tertiary) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ButtonTertiary) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-19609&t=H9FWVKuV1aX5wYth-1)
 */
var ButtonTertiary = exports.ButtonTertiary = Object.assign(ButtonComponent, buttonHelpers);